export class ValidationMessage {
    key: string;
    message: string;
    category: string;
}
